import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { YoutubeEmbedVideoComponent } from '../../../new-v2-component/youtube-embed-video/youtube-embed-video.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'sm-unpaid-invoices',
  templateUrl: './unpaid-invoices.component.html',
  styleUrls: ['./unpaid-invoices.component.scss']
})
export class UnpaidInvoicesComponent implements OnInit {
  repeatArray:any
  unpaidInvoicesData: any = {}
  toshowData:boolean =true
  loader: boolean = false
  _apisub: Subscription
  constructor(private _apiservice:ApiService,private router: Router,  private dialog:MatDialog) {

    this._apisub = this._apiservice.apiResult.subscribe(resdata =>{
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_LATEST_UNPAID_INVOICE_STATUS_COUNT_FOR_DASHBOARD){
        this.unpaidInvoicesData = {}
        if(resdata.result){
          this.unpaidInvoicesData = resdata.result
        }
        
        this.loader = false
      }
    })

   }

  ngOnInit(): void {
    this.loader = true
    this._apiservice.getLatestUnpaidInvoiveStatusCountForDashboard()
  }

  viewAll(){
    if(this.unpaidInvoicesData?.total_unpaid_invoices > 0){
      this.router.navigate(['all-unpaid-invoices'])

    }
  }

  openvideo(){
    this.dialog.open(YoutubeEmbedVideoComponent,{
    width:'1000px',
    disableClose:true,
    data:{
      link:"",
      title: 'Expenditure'
    }})
    }

}
